export default function ClientsPage() {
  return (
    <div>
      <h1 className="text-display-lg text-navy mb-4">Clients</h1>
      <p className="text-warm-gray">This page is under construction.</p>
    </div>
  );
}
